<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("releaseseat") }}</div>
    </div>

    <div class="white-wrapper mt-4">
      <div class="row justify-content-center">
        <div class="col-md-4">
          <div class="input-material w-100">
            <input
              v-model="ticketno"
              v-validate="'required'"
              name="ticketno"
              id="ticketno"
              placeholder="."
              type="search"
            />
            <label>Ticket No.</label>
          </div>
          <div class="error_message">
            <span v-if="submitted && errors.has('ticketno')">{{
              errors.first("ticketno")
            }}</span>
          </div>

          <div class="text-center mt-3">
            <button
              :disabled="btenable"
              @click.prevent.stop="OnSubmit()"
              class="btn-blue"
              >Submit</button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";

  export default {
    data() {
      return {
        btenable: false,
        ticketno: "",
        submitted: false,
      };
    },
    beforeMount() {
      if (
        !this.$can("create", "Release Seat") ||
        !this.$can("update", "Release Seat")
      ) {
        this.$router.push({
          path: "/access-denied",
        });
      }
    },
    methods: {
      OnSubmit: function() {
        this.submitted = true;

        this.$validator.validate().then((valid) => {
          if (valid) {
            this.btenable = true;
            MasterService.ReleaseSeat({ ticket_code: this.ticketno }).then(
              (response) => {
                this.btenable = false;
                const { data } = response;

                if (data.status) {
                  this.ticketno = "";
                  this.submitted = false;

                  this.$toasted.show(data.message);
                }
              }
            );
          }
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ReleaseSeat/releaseSeat.vue